<template>
<b-row class="flex-grow-1 p-4">
        <b-col>
            <b-row class="pb-4">
                <b-col>
                    <map-search
                        :search-text="menuComponents.mapControls.components.search.textToSearch"
                        :search-suggestions="menuComponents.mapControls.components.search.suggestions"
                        :search-show-suggestions="menuComponents.mapControls.components.search.showResults"
                        mode="accessible"
                        @open="openSearchResult($event)"
                        @reset="searchFromMenuBar({searchText: undefined})"
                        @updateDebounced="searchFromMenuBar({searchText: $event})"
                        @update="$_updateSearchText({searchText: $event})"
                        @focus="$_onFocus()"
                        @blur="searchIsFocussed = false"
                    ></map-search>
                </b-col>
            </b-row>
            <b-row v-if="hasResults && !searchIsFocussed" class="pb-4">
                <b-col>
                    <information-overview-tab
                        v-if="hasResults && !searchIsFocussed"
                        class="accessible"
                        mode="accessible"
                    />
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script>
    import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

    import SearchInput from '../navbar/SearchInput.vue';
    import InformationOverviewTab from '../information';

    export default {
        components: {
            'map-search': SearchInput,
            'information-overview-tab': InformationOverviewTab
        },
        data() {
            return { searchIsFocussed: false };
        },
        computed: {
            ...mapState(['uiElements']),
            ...mapGetters(['getWebTheme']),
            menuComponents: function() {
                return this.uiElements.menuBar.components;
            },
            showSearch() {
                return this.getWebTheme?.data?.showSearch;
            },
            hasResults() {
                return this.$store.state.selections.length > 0;
            }
        },
        methods: {
            ...mapActions(['searchFromMenuBar', 'openSearchResultFromMenuBar', 'togglePanel']),
            ...mapMutations(['ADD_SELECTION']),
            openSearchResult(data) {
                this.$store.state.accessibility.newSearch = true;
                this.ADD_SELECTION({ results: [] });
                this.openSearchResultFromMenuBar(data);
                this.searchIsFocussed = false;
                if (data.type === 'address') {
                    this.openInfo();
                }
            },
            openInfo() {
                this.$router.push({ name: 'accessibleInfo' });
            },
            $_updateSearchText(searchText) {
                this.$store.commit('UPDATE_SEARCH_SEARCHTEXT', searchText);
            },
            $_onFocus() {
                this.searchIsFocussed = true;
                let text = 'Zoekveld';
                const input = this.menuComponents.mapControls.components.search.textToSearch;
                if (input && input.length > 0) {
                    text += `, met invoer, ${input}`;
                }
                this.$store.dispatch('say', { text });
            }
        },
        watch: {
            'menuComponents.mapControls.components.search.suggestions': function(newVal) {
                if (!newVal) {
                    this.$store.dispatch('stopSpeaking');
                    return;
                }
                const nResults = Object.entries(newVal).flatMap(group => group[1]).length;
                const text = `${nResults} suggesties, door loop met pijltjes of tab`;
                this.$store.dispatch('say', { text });
            }
        }
    };
</script>
